/* Navigation enhancement only. No content rewriting, forms, cookies, analytics or external requests. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-oti-navigation]').forEach((navigation) => {
      if (navigation.dataset.otiReady) return;
      navigation.dataset.otiReady = 'true';
      const desktop = window.matchMedia('(min-width: 900px)');
      const setState = () => { navigation.open = desktop.matches; };
      setState();
      if (desktop.addEventListener) desktop.addEventListener('change', setState);
      navigation.addEventListener('toggle', () => {
        if (desktop.matches && !navigation.open) navigation.open = true;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
